/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { fetchLease } from '../../lib/rest/leaseAPIClient'
import LeaseForm from './LeaseForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import useParsedQueryParam from '../../../../client/js/hooks/useParsedQueryParam'
import { parseNumber } from '@jalik/form-parser'
import Page from '../../../../client/js/components/Page'
import LeaseBreadcrumb from './LeaseBreadcrumb'

function LeaseFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const leaseId = parseInt(params.id, 10)
  const [searchParams] = useQueryParams()
  const estateId = useParsedQueryParam('estateId', parseNumber)
  const lessorId = useParsedQueryParam('lessorId', parseNumber)
  const tenantId = useParsedQueryParam('tenantId', parseNumber)

  const leaseQuery = useQuery({
    enabled: true,
    queryKey: ['lease', leaseId, searchParams],
    queryFn: () => leaseId > 0
      ? fetchLease(leaseId)
      : Promise.resolve({
        estateId,
        lessorId,
        tenantId
      } as Partial<Lease>),
    refetchOnWindowFocus: false
  })
  const { data } = leaseQuery

  const title = leaseId > 0 && data != null
    ? data.reference
    : intl.formatMessage({
      id: 'create_rental_file',
      defaultMessage: 'Créer un dossier de location'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <LeaseBreadcrumb
          lease={leaseQuery.data}
          title={title}
        />

        <Card shadow="sm">
          <LoadingHelper
            query={leaseQuery}
            render={() => (
              <LeaseForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default LeaseFormPage
